import { render } from "./ModuleReportView.vue?vue&type=template&id=6c3c17c9"
import script from "./ModuleReportView.vue?vue&type=script&lang=js"
export * from "./ModuleReportView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__